import React from 'react'
import IconButton from '@material-ui/core/IconButton'
import { makeStyles } from '@material-ui/core/styles'
import Tooltip from '@material-ui/core/Tooltip'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'

const useStyles = makeStyles({
  arrow: {
    '&:before': {
      border: '1px solid #B2B2B2',
    },
    color: '#F3F3F4',
  },
  tooltip: {
    backgroundColor: '#F3F3F4',
    color: '#4C4D68',
    width: 260,
    fontSize: '14px',
    fontWeight: 300,
    border: '1px solid #B2B2B2',
    borderRadius: 12,
    padding: '16px 18px',
    lineHeight: '20px',
    fontFamily: 'Libre Franklin',
  },
})

const useIconStyles = makeStyles({
  root: {
    height: 0,
    padding: '0px 0px 0px 12px',
  },
})

interface TooltipProps {
  toolTipContent: React.ReactFragment
  label?: string
}

const StyledTooltip: React.FC<TooltipProps> = ({ toolTipContent, label }) => {
  const classes = useStyles()
  const iconClasses = useIconStyles()
  const mediaMobile = useMediaQuery('(min-width:600px)')
  return (
    <Tooltip classes={classes} arrow title={toolTipContent} placement={mediaMobile ? 'right' : 'bottom-end'}>
      <IconButton className={iconClasses.root} aria-label={[label, 'information'].join(' ')}>
        <InfoOutlinedIcon />
      </IconButton>
    </Tooltip>
  )
}

export default StyledTooltip
